import {
  getTaxInformationMetaById,
  removeNonAlphanumeric,
} from "./tax-information.utils";

const taxInformationFormValidation = (
  { taxInformation },
  { taxInformationId, intl },
) => {
  const { shortNameMessageDescriptor, validationFn } =
    getTaxInformationMetaById(taxInformationId);

  const cleanValue = removeNonAlphanumeric(taxInformation ?? "");

  const errorMessage = intl.formatMessage(
    {
      id: "hosting.tax_information_form.invalid_input_error_message",
      defaultMessage: "Please enter a valid {taxIdShortName}.",
    },
    { taxIdShortName: intl.formatMessage({ ...shortNameMessageDescriptor }) },
  );

  const { isValid } = validationFn(cleanValue);
  return {
    taxInformation: !isValid ? [errorMessage] : undefined,
  };
};

export { taxInformationFormValidation };
